import { NextButton } from "../NextButton/NextButton";
import { ViewResumeAnchor } from "../../ui/atoms/ViewResumeBtn";
import { PersonalPhoto2 } from "../../shared/assets/index";


export function AboutContent() {
  return (
    <div className={'flex flex-col-reverse gap-4 pt-[14rem] pb-[10rem] md:flex-row px-[7.5%] text-[#f7f7f7] font-nunito relative py-[2rem] w-full min-h-screen'}>
      <div className={'p-[2rem] relative '}>
        <div className={`relative z-[5] `}>
          {/* this div is for clip path */}
          <img src={PersonalPhoto2}
            className="mx-auto w-[200px] rounded-full h-[200px]  hidden md:block object-cover grayscale-[120%]"
            alt="Samuel (Fullstack Developer)" />
        </div>
      </div>
      <div className={`basis-[60%] py-[4rem] px-[5%] bg-dark-500`}>
        <img src={PersonalPhoto2}
          className="rounded-full w-[25vw] h-[25vw]  object-cover grayscale-[120%] mb-12 md:hidden"
          alt="Samuel (Fullstack Developer)" />
        <h1 className="text-base md:text-xl tracking-wider font-nunito font-bold text-primary-500">
          About Me
        </h1>

        <p className="text-base/[2] mt-2 font-nunito tracking-wide shadow-sm rounded-sm mb-8">
          Hey! I’m a problem solver, full-stack Developer, AI Enthusiast, and a builder who loves building smart, scalable, and meaningful web experiences. I am a solution and result driven software developer with 4+ years of experience in frontend development and ~ 1 year of experience in backend development. I specialize in the MERN stack, TypeScript, and NestJS, with a growing obsession for weaving AI into everyday applications to make them more intelligent and intuitive.

          Over the years, I’ve worked on a variety of projects that can be found on my <a href="https://github.com/chiefcipher" target="_blank" rel="noopener noreferrer" className="text-primary-500">GitHub</a> or <a href="/projects" target="_blank" rel="noopener noreferrer" className="text-primary-500">here</a> on my website.

          <br />
          <br />

          I'm also an Open-Source Advocate — I believe in building with and for the community. I love contributing tools, utilities, and improvements that make development easier for others.

          <br />
          <br />
          I’m dedicated to building scalable backends, dynamic frontends, and
          efficient APIs while continually exploring new ways to innovate and
          improve.
          <br />
          <br />
          Outside of coding, I channel my discipline into bodybuilding, focusing
          on bulking and achieving peak physical performance. My multifaceted
          approach to life combines creativity, technical expertise, and a drive
          to excel in all pursuits.
        </p>
        <div className="ml-auto w-fit">

          <ViewResumeAnchor />
        </div>
      </div>
      <NextButton nextRoute="/skills" />
    </div>
  );
}
